// Import modules
import activateToggle from './modules/menuToggle';
import menuShowOnScroll from './modules/menuShowOnScroll';
import activateDropdowns from './modules/menuDropdown';
import menuDropdownWidth from './modules/menuDropdownWidth';
import menuSearch from './modules/menuSearch';
import productFilter from './modules/productFilter';
import readMore from './modules/readMore';

window.addEventListener('load', () => {
  // Initialize modules
  activateToggle();
  menuShowOnScroll();
  activateDropdowns();
  menuDropdownWidth();
  menuSearch();
  productFilter();
  readMore();
});

window.addEventListener('resize', () => {
  // Initialize modules
  menuDropdownWidth();
});
